import juice from 'juice';

export const buildEmailHtml = (rawHtml, isDarkMode) => {
  const baseTemplate = `
  <div style="
    font-family: Arial, sans-serif;
    font-size: 14px;
    color: ${isDarkMode ? '#fff' : '#000'};
    background-color: ${isDarkMode ? '#374151' : '#dbeafe'};
    padding: 16px;
  ">
    ${rawHtml}
  </div>
`;

  return juice(baseTemplate, {
    removeStyleTags: true,
    preserveMediaQueries: false,
  });
};
